import { render } from "./logs.vue?vue&type=template&id=276bd30e&scoped=true"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276bd30e"]])

export default __exports__